import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { Modal, Button } from 'react-bootstrap';
import { putRequest } from '../../../requestUtils';
import './TransferApplication.scss';
function TransferApplication(_ref) {
  var triggerText = _ref.triggerText,
    _ref$buttonStyles = _ref.buttonStyles,
    buttonStyles = _ref$buttonStyles === void 0 ? '' : _ref$buttonStyles,
    _ref$triggerType = _ref.triggerType,
    triggerType = _ref$triggerType === void 0 ? 'button' : _ref$triggerType,
    idKey = _ref.idKey,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$biggerButton = _ref.biggerButton,
    biggerButton = _ref$biggerButton === void 0 ? false : _ref$biggerButton,
    _ref$applicationType = _ref.applicationType,
    applicationType = _ref$applicationType === void 0 ? 'Proposal' : _ref$applicationType,
    applicationProject = _ref.applicationProject,
    csrfToken = _ref.csrfToken,
    _ref$proposaltResourc = _ref.proposaltResourceId,
    proposaltResourceId = _ref$proposaltResourc === void 0 ? '' : _ref$proposaltResourc,
    _ref$interestResource = _ref.interestResourceId,
    interestResourceId = _ref$interestResource === void 0 ? '' : _ref$interestResource,
    selectOptions = _ref.selectOptions,
    _ref$open = _ref.open,
    open = _ref$open === void 0 ? undefined : _ref$open,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? null : _ref$onClose;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showModal = _useState2[0],
    setShowModal = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedProject = _useState4[0],
    setSelectedProject = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isProcessing = _useState6[0],
    setIsProcessing = _useState6[1];
  var isControlled = open !== undefined;
  var isOpen = isControlled ? open : showModal;
  var handleOpenModal = function handleOpenModal() {
    return setShowModal(true);
  };
  var handleCloseModal = function handleCloseModal() {
    if (!isControlled) setShowModal(false);
    if (onClose) onClose();
  };
  var handleInputChange = function handleInputChange(option) {
    return setSelectedProject(option);
  };
  var handleSubmit = function handleSubmit() {
    var applicationId = applicationType === 'Proposal' ? proposaltResourceId : interestResourceId;
    setIsProcessing(true);
    putRequest("/projects/".concat(selectedProject.value, "/transfer_application"), {
      application_id: applicationId,
      application_type: applicationType
    }, csrfToken).then(function () {
      if (typeof window !== 'undefined') {
        window.location.href = "/projects/".concat(selectedProject.value, "?tab=proposals");
      }
    })["catch"](function () {
      return setIsProcessing(false);
    });
  };
  var renderTrigger = function renderTrigger() {
    if (isControlled) return null;
    if (triggerType === 'link') {
      return /*#__PURE__*/React.createElement("a", {
        className: "application-transfer-anchor-trigger ".concat(buttonStyles),
        tabIndex: 0,
        role: "button",
        onClick: function onClick(e) {
          e.preventDefault();
          handleOpenModal();
        },
        id: "".concat(idKey, "-link"),
        disabled: disabled,
        href: "#modal-trigger-open"
      }, triggerText);
    }
    return /*#__PURE__*/React.createElement(Button, {
      variant: buttonStyles,
      className: "".concat(biggerButton ? 'bigger-button' : ''),
      onClick: handleOpenModal,
      id: "".concat(idKey, "-button"),
      disabled: disabled
    }, triggerText);
  };
  return /*#__PURE__*/React.createElement(Fragment, null, renderTrigger(), /*#__PURE__*/React.createElement(Modal, {
    show: isOpen,
    onHide: handleCloseModal,
    dialogClassName: "application-transfer-modal",
    size: "lg"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("h1", {
    className: "fs-3"
  }, "Transfer ".concat(applicationType, " Application")), /*#__PURE__*/React.createElement("div", {
    className: "select-input"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "selected-project"
  }, "Select Project"), /*#__PURE__*/React.createElement(Select, {
    className: "basic-single",
    classNamePrefix: "select",
    defaultValue: selectedProject,
    value: selectedProject,
    isClearable: true,
    isSearchable: true,
    inputId: "selected-project",
    name: "selected-project",
    options: selectOptions,
    onChange: function onChange(e) {
      return handleInputChange(e || '');
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "application-info"
  }, /*#__PURE__*/React.createElement("span", {
    className: "sub-header"
  }, "Move Application"), /*#__PURE__*/React.createElement("div", {
    className: "from-info"
  }, /*#__PURE__*/React.createElement("span", null, "From:"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "Project:", /*#__PURE__*/React.createElement("strong", null, (applicationProject === null || applicationProject === void 0 ? void 0 : applicationProject.label) || '')), /*#__PURE__*/React.createElement("li", null, "Status:", /*#__PURE__*/React.createElement("strong", null, (applicationProject === null || applicationProject === void 0 ? void 0 : applicationProject.status) || '')), /*#__PURE__*/React.createElement("li", null, "Company:", /*#__PURE__*/React.createElement("strong", null, (applicationProject === null || applicationProject === void 0 ? void 0 : applicationProject.company) || '')))), /*#__PURE__*/React.createElement("div", {
    className: "to-info"
  }, /*#__PURE__*/React.createElement("span", null, "To:"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "Project:", /*#__PURE__*/React.createElement("strong", null, (selectedProject === null || selectedProject === void 0 ? void 0 : selectedProject.label) || '')), /*#__PURE__*/React.createElement("li", null, "Status:", /*#__PURE__*/React.createElement("strong", null, (selectedProject === null || selectedProject === void 0 ? void 0 : selectedProject.status) || '')), /*#__PURE__*/React.createElement("li", null, "Company:", /*#__PURE__*/React.createElement("strong", null, (selectedProject === null || selectedProject === void 0 ? void 0 : selectedProject.company) || '')))))), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement("div", {
    className: "action-buttons justify-content-center"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn-cancel",
    onClick: handleCloseModal
  }, "Cancel"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn-save",
    onClick: handleSubmit,
    disabled: selectedProject === ''
  }, isProcessing ? 'Save...' : 'Save')))));
}
TransferApplication.propTypes = {
  triggerText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  buttonStyles: PropTypes.string,
  triggerType: PropTypes.oneOf(['link', 'button']),
  idKey: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  biggerButton: PropTypes.bool,
  applicationType: PropTypes.string,
  applicationProject: PropTypes.shape({
    label: PropTypes.string,
    status: PropTypes.string,
    company: PropTypes.string
  }).isRequired,
  csrfToken: PropTypes.string.isRequired,
  proposaltResourceId: PropTypes.string,
  interestResourceId: PropTypes.string,
  selectOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func
};
export default TransferApplication;